var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tab',_vm._b({scopedSlots:_vm._u([{key:"title",fn:function(){return [(_vm.$slots[_vm.publicSlots.label])?_vm._t(_vm.publicSlots.label):_c('span',[_vm._v("\n            "+_vm._s(_vm.label)+"\n        ")])]},proxy:true}],null,true)},'b-tab',{ ..._vm.$attrs, ..._vm.$props },false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }